export const FETCH_APPOINTMENT_TIME = "FETCH_APPOINTMENT_TIME";
